import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { FaCircleInfo } from "react-icons/fa6";
import { FiArrowLeft, FiCalendar } from "react-icons/fi";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import lgbtqIcon from '../../../../../assets/images/lgbtq.png';
import LocateBed from "../../../../../assets/images/locate-bed.svg";
import InputBox from "../../../../../Components/Input";
import Loader from "../../../../../Components/Loader";
import ModalDailog from "../../../../../Components/Modal";
import RadioButton from "../../../../../Components/RadioButton";
import { showToast } from "../../../../../Components/ToastNotification";
import Tooltip from "../../../../../Components/Tooltip";
import useAgencies from "../../../../../hooks/useAgencies";
import useMyAgencyData from "../../../../../hooks/useMyAgencyData";
import useSocket from "../../../../../services/socketService";
import { Agency, AgencyResponses, disabilityAccessible, gendersServed, locationType, roomType, urbanRuralClassification } from "../../../../../type/Agency";
import { CloseReason, closeReasons } from "../../../../../type/Response";
import { API_ENDPOINTS } from "../../../../../utils/api";
import createAxiosInstance from "../../../../../utils/axiosInstance";
import { formatDateShort, formatDateTime } from "../../../../../utils/formatters";
import { availabilityByResponse, formatUrl, getElements, getOther, isValidURL } from "../../../../../utils/helper";
import { useFeature } from "../../../../../hooks/useFeature";

interface Response {
  responseId: string;
  response: string;
}

interface Request {
  requestId: string;
  responses: Response[];
  status: string;
  createdAt: string;
}

const SentDetail = () => {
  const hasCollaboratives = useFeature("bedfinder:collaboratives");
  const navigate = useNavigate();
  const location = useLocation();
  const { requestId } = useParams();
  const myShelter = useMyAgencyData();
  const { agencies, agenciesById } = useAgencies();
  const axiosInstance = createAxiosInstance();

  // show hide modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenSheltercc, ModalOpenSheltercc] = useState(false);
  const [request, setRequest] = useState<any>({});
  const requestRef = useRef<Request>(request);
  const [agencyData, setAgencyData] = useState<any>({});
  const [isLoding, setIsLoding] = useState(true);

  const defaultValues = {
    reason: "" as CloseReason,
    other: "",
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues,
  });

  const tabs = [{
    id: 0,
    title: "Possible Beds",
    key: "possible"
  }, {
    id: 1,
    title: "No Beds Available",
    key: "no"
  }, {
    id: 2,
    title: "Response Pending",
    key: "null"
  }];

  // tab props
  const [activeTabs, setActiveTabs] = useState(0);
  useEffect(() => {
    if (agenciesById) {
      getMyRequest();
    }
  }, [agenciesById]);

  const { on } = useSocket("requests");

  useEffect(() => {
    requestRef.current = request;
  }, [request]);

  useEffect(() => {
    const unsubscribe = on("message", (data) => {
      if (data.eventType === "success" || data.eventType === "reject") {
        if (data.data.requestId === requestId) {
          const isFirstResponse = requestRef.current?.responses?.some(
              (response: Response) =>
                response.responseId === data.data.responseId &&
                response.response === "null"
            );
    
          if (isFirstResponse) {
            showToast("An agency responded to your request.", "info");
          } else {
            showToast("An agency changed a response.", "info");
          }
          getMyRequest();
        }
      }
    });

    return unsubscribe;
  }, []);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const openModalCC = (agencyDetails: any) => {
    const groupId = Array.isArray(agencyDetails.groupId)
      ? agencyDetails.profile?.defaultGroupId || agencyDetails.groupId[0]
      : null;

    const { regionalSupporter, canAnswerRequest, canSendRequest } =
      agencyDetails.groupInfo?.find((groupInfo: any) => groupInfo?.groupId === groupId) || {};

    const data = {
      id: agencyDetails.id,
      data: agencyDetails,
      groupId: groupId,
      regionalSupporter: regionalSupporter,
      canAnswerRequest: canAnswerRequest,
      isReferral: !canAnswerRequest && canSendRequest,
      city: ((agencyDetails.details?.city || "").split(",")[0] || "").trim(),
      state: (
        agencyDetails.details?.state ||
        (agencyDetails.details?.city || "").split(",")[1] ||
        ""
      ).trim()
    };

    setAgencyData(data);
    ModalOpenSheltercc(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const closeModalSheltercc = () => {
    ModalOpenSheltercc(false);
  };

  //  radio button value checked
  const [selectedValue, setSelectedValue] = useState("");

  const getMyRequest = async () => {
    try {
      const response = await axiosInstance.get(`${API_ENDPOINTS.BEDFINDER.GETMYREQUEST}?status=*&expand=need/assessments,responses`);

      const data = response.data.find((it: any) => it.requestId === requestId); // Extract the actual data

      setRequest({ ...data });
      setIsLoding(false);
    } catch (error) {
      setIsLoding(false);
      console.log(error);
    }
  };

  const agencyResponses = agencies
    ?.filter(
      (agency: any) =>
        agency.groupInfo?.some(
          (currentInfo: any) =>
            request?.need?.groupId?.includes(currentInfo.groupId) &&
            currentInfo.canAnswerRequest &&
            currentInfo.groupId != myShelter?.agencyId,
        ),
    )
    .filter((agency: any) => agency.agencyId != myShelter?.agencyId)
    .reduce(
      (responses: any, agency: any) => {
        const responseWithAgency = request?.responses?.find(
          (it: any) => it.agencyId == agency?.agencyId,
        );
        const agencyResponse = responseWithAgency?.response;
        if (!agencyResponse) return responses;

        (agencyResponse === "no"
          ? responses.no
          : agencyResponse === "null"
            ? responses.null
            : responses.possible
        ).push({
          availability:
            availabilityByResponse[responseWithAgency?.response] || null,
          agencyDetails: agenciesById[agency?.agencyId],
          modifiedAt: responseWithAgency?.modifiedAt,
        });

        return responses;
      },
      { possible: [], no: [], null: [] } as AgencyResponses,
    );

  const handleTabChange = (tabId: number) => {
    setActiveTabs(tabId);
  };

  const closeRequestHandler: SubmitHandler<any> = async (formData) => {
    try {
      setIsLoding(true);
      const closeRequestPayload: any = {
        request: {
          reason: formData.reason,
        },
        status: "closed"
      };

      if (formData.reason === "other") {
        closeRequestPayload.request.other = formData.other;
      }

      const closeRequest = await axiosInstance.put(
        API_ENDPOINTS.BEDFINDER.CLOSEREQUEST.replace(
          "{requestId}",
          request.requestId
        ),
        closeRequestPayload
      );

      const closeNeedPayload: any = {
        status: "closed",
      };

      const closeNeed = await axiosInstance.put(
        API_ENDPOINTS.BEDFINDER.CLOSENEED.replace(
          "{needId}",
          request.needId
        ),
        closeNeedPayload
      );

      if (closeRequest.status === 200 && closeNeed.status === 200) {
        getMyRequest();
        closeModal();
        setIsLoding(false);
        showToast("The request was successfully closed.", "success");
      }
    } catch (error) {
      setIsLoding(false);
      showToast("An error occurred while submitting the request. Please try again.", "error");
      console.log(error);
    }
  };

  // pagination page
  return (
    (isLoding && <Loader />) ||
    request?.requestId && (
      <>
        <div key={request.requestId} className=" bg-white">
          <div className="container py-4 md:py-10 2xl:py-[70px]">
            <div className="card p-0 mt-6 overflow-hidden">
              <div className="card-header flex flex-wrap items-center justify-between p-3 lg:p-5 border border-b text-gray-600 text-xs lg:text-sm 2xl:text-base font-medium gap-3">
                <div className="flex flex-wrap items-center space-x-4">
                  <div className="flex items-center gap-3">
                    <img src={LocateBed} alt="LocateBed" className="w-8" />
                    <div>
                      Reference : <Link to={'#'} className="font-semibold">{request?.need?.caseReferenceId}</Link>
                    </div>
                  </div>
                  <span className="text-blue-100">|</span>
                  {request?.status === "open" && (
                    <span className="bg-success50 text-success text-xs 2xl:text-sm p-1 px-2 rounded-full flex items-center gap-1 w-fit font-medium">
                      Open
                    </span>
                  )}
                  {request?.status === "closed" && (
                    <span className="bg-orange-50 text-error text-xs 2xl:text-sm p-1 px-2 rounded-full flex items-center gap-1 w-fit font-medium">
                      Closed
                    </span>
                  )}
                </div>
                <div className="flex items-center mt-4 sm:mt-0">
                  <FiCalendar className="me-3" size={20} />
                  <span>{formatDateShort(request?.need?.createdAt)}</span>
                </div>
              </div>
              <div className="card-body p-3 lg:p-5">
                <div className="border rounded-xl p-4">
                  {request?.need?.status == "closed" && (
                    <div className="fix-block">
                      <div className="text-xs 2xl:text-sm text-gray-700 font-normal mb-4">
                        Reason : <span className="font-semibold to-gray-800 ms-2">{request?.request?.reason == "other"
                          ? request?.request?.other
                          : request?.request?.reason}</span>
                      </div>
                    </div>
                  )}
                  {request?.status == "open" && (
                    <div className="fix-block">
                      {request?.need?.assessments?.[0]?.age && (
                        <div className="text-xs 2xl:text-sm text-gray-700 font-normal mb-4">
                          Age : <span className="font-semibold to-gray-800 ms-2">{request?.need?.assessments[0]?.age}</span>
                        </div>
                      )}
                      {getOther(
                        request?.need?.assessments?.[0],
                        "currentHousingSituation",
                      ) && (
                          <div className="text-xs 2xl:text-sm text-gray-700 font-normal mb-4">
                            Current housing situation : <span className="font-semibold to-gray-800 ms-2">{getOther(
                              request?.need?.assessments?.[0],
                              "currentHousingSituation",
                            )}</span>
                          </div>
                        )}
                      {request?.need?.assessments?.[0]?.accompanyingChildren && (
                        <div className="text-xs 2xl:text-sm text-gray-700 font-normal mb-4">
                          Children : <span className="font-semibold to-gray-800 ms-2">{getElements(
                            request?.need?.assessments?.[0]?.accompanyingChildren,
                          )}</span>
                        </div>
                      )}
                      {request.need.assessments?.[0]?.accompanyingChildrenDetails &&
                        request.need.assessments[0].accompanyingChildrenDetails.map((child: any, __id: any) => (
                          <div className="text-xs 2xl:text-sm text-gray-700 font-normal mb-4" key={"details" + __id}>
                            <div>
                              <span>
                                Age  : <span className="font-semibold to-gray-800 ms-2">{child.age}</span>
                              </span>
                            </div>
                          </div>
                        ))}
                      {request?.need?.assessments?.[0]?.history && (
                        <div className="text-xs 2xl:text-sm text-gray-700 font-normal mb-4">
                          Violence/aggression/self-harming behaviors :<span className="font-semibold to-gray-800 ms-2">{getElements(request?.need?.assessments?.[0]?.history)}</span>
                        </div>
                      )}
                      {request?.need?.assessments?.[0]?.mentalHealth && (
                        <div className="text-xs 2xl:text-sm text-gray-700 font-normal mb-4">
                          Current mental health :<span className="font-semibold to-gray-800 ms-2">{request?.need?.assessments?.[0]?.mentalHealth}</span>
                        </div>
                      )}
                      {request?.need?.assessments?.[0]?.currentSubstanceUse && (
                        <div className="text-xs 2xl:text-sm text-gray-700 font-normal mb-4">
                          Current substance use :<span className="font-semibold to-gray-800 ms-2">{request?.need?.assessments?.[0]?.currentSubstanceUse}</span>
                        </div>
                      )}
                      {request?.need?.assessments?.[0]?.primaryLanguage && (
                        <div className="text-xs 2xl:text-sm text-gray-700 font-normal mb-4">
                          Primary Language :<span className="font-semibold to-gray-800 ms-2">{request?.need?.assessments?.[0]?.primaryLanguage}</span>
                        </div>
                      )}
                      {request?.need?.assessments?.[0]?.secondaryLanguage && (
                        <div className="text-xs 2xl:text-sm text-gray-700 font-normal mb-4">
                          Secondary Language :<span className="font-semibold to-gray-800 ms-2">{request?.need?.assessments?.[0]?.secondaryLanguage}</span>
                        </div>
                      )}
                      {getOther(request?.need?.assessments?.[0], "languageSpoken") && (
                        <div className="text-xs 2xl:text-sm text-gray-700 font-normal mb-4">
                          Language spoken :<span className="font-semibold to-gray-800 ms-2">{getOther(request?.need?.assessments?.[0], "languageSpoken")}</span>
                        </div>
                      )}
                      {request?.need?.assessments?.[0]?.englishProficiency && (
                        <div className="text-xs 2xl:text-sm text-gray-700 font-normal mb-4">
                          English Proficiency :<span className="font-semibold to-gray-800 ms-2">{request?.need?.assessments?.[0]?.englishProficiency}</span>
                        </div>
                      )}
                      {getOther(
                        request?.need?.assessments?.[0],
                        "traffickingSituation",
                      ) && (
                          <div className="text-xs 2xl:text-sm text-gray-700 font-normal mb-4">
                            Type of trafficking or violence :<span className="font-semibold to-gray-800 ms-2">{getOther(
                              request?.need?.assessments?.[0],
                              "traffickingSituation",
                            )}</span>
                          </div>
                        )}
                      {getOther(
                        request?.need?.assessments?.[0],
                        "physicalDisability",
                      ) && (
                          <div className="text-xs 2xl:text-sm text-gray-700 font-normal mb-4">
                            Physical disability or mobility concerns :<span className="font-semibold to-gray-800 ms-2">{getOther(
                              request?.need?.assessments?.[0],
                              "physicalDisability",
                            )}</span>
                          </div>
                        )}
                      {request?.need?.assessments?.[0]?.additionalInformation && (
                        <div className="text-xs 2xl:text-sm text-gray-700 font-normal mb-4">
                          What other information about your client and their situation is helpful in finding appropriate shelter for them? (Optional) :<span className="font-semibold to-gray-800 ms-2">{request?.need?.assessments?.[0]?.additionalInformation}</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Card Body */}
            <div className="card-body mt-5">
              {/* Tab Navigation */}
              <div className="flex justify-between items-center">
                <div className="flex border border-borderGray rounded-lg mb-5 md:w-fit shadow-sm overflow-hidden">
                  {tabs.map((tab) => (
                    <button
                      key={tab.id}
                      className={`p-2 text-xs md:text-sm md:w-48 justify-center border-r border-borderGray last:border-r-0 2xl:text-base font-medium flex items-center gap-2 ${activeTabs === tab.id
                        ? "bg-gray-100 text-gray-800"
                        : "text-gray-600 hover:text-gray-800"
                        }`}
                      onClick={() => handleTabChange(tab.id)}
                    >
                      {tab.title}
                      {agencyResponses[tab.key]?.length > 0 && (
                        <span className={`min-w-6 w-6 h-6 flex justify-center items-center rounded-3xl  ${tab.id === 0 ? "bg-success text-white" : tab.id === 1 ? "bg-white border border-gray-400 text-gray-600" : "bg-white border border-gray-400 text-gray-600"}`}>
                          {agencyResponses[tab.key]?.length}
                        </span>
                      )}
                    </button>
                  ))}
                </div>
              </div>
              <div className="tab-content">
                {tabs.map((tab) => (
                  <div
                    key={tab.id}
                    className={`tab-pane ${activeTabs === tab.id ? "block" : "hidden"}`}
                  >
                    {agencyResponses[tab.key]?.length > 0 && (
                      <div className="relative md:overflow-hidden md:border md:border-borderGray rounded-xl">
                        <table className="table_responsive_block  w-full text-xs lg:text-sm text-left rtl:text-right">
                          <thead className="text-sm text-gray-600 bg-gray-50 border-b">
                            <tr>
                              <th scope="col" className="px-4 2xl:px-6 py-3 font-medium">Agency</th>
                              {activeTabs === 0 && <th scope="col" className="px-4 2xl:px-6 py-3 font-medium">Availability</th>}
                              <th scope="col" className="px-4 2xl:px-6 py-3 font-medium">Response Date</th>
                              <th scope="col" className="px-4 2xl:px-6 py-3 font-medium">City</th>
                              <th scope="col" className="px-4 2xl:px-6 py-3 font-medium">State</th>
                              <th scope="col" className="px-4 2xl:px-6 py-3 font-medium">Email</th>
                              <th scope="col" className="px-4 2xl:px-6 py-3 font-medium">Phone Number</th>
                            </tr>
                          </thead>
                          <tbody>
                            {agencyResponses[tab.key]?.map((responseItem: any) => (
                              <tr className="bg-white border-b">
                                {hasCollaboratives ? (
                                  <td data-title='Agency' scope="row" className="px-4 2xl:px-6 py-3 font-medium text-primary cursor-pointer whitespace-nowrap" onClick={() => openModalCC(responseItem?.agencyDetails)}>
                                    {responseItem?.agencyDetails?.name ?? ""}
                                  </td>
                                ) : (
                                  <td data-title='Agency' scope="row" className="px-4 2xl:px-6 py-3 font-medium whitespace-nowrap">
                                    {responseItem?.agencyDetails?.name ?? ""}
                                  </td>
                                )}
                                {activeTabs === 0 && (
                                  <td data-title='Availability' className="px-4 2xl:px-6 py-3">{responseItem?.availability}</td>
                                )}
                                <td data-title='Response Date' className="px-4 2xl:px-6 py-3">{activeTabs == 2 ? "-" : formatDateTime(responseItem?.modifiedAt)}</td>
                                <td data-title='City' className="px-4 2xl:px-6 py-3">{responseItem?.agencyDetails?.details?.city ?? ""}</td>
                                <td data-title='State' className="px-4 2xl:px-6 py-3">{responseItem?.agencyDetails?.details?.state ?? ""}</td>
                                <td data-title='Email' className="px-4 2xl:px-6 py-3"><span className='truncate'> {responseItem?.agencyDetails?.details?.referral?.email ?? ""}</span></td>
                                <td data-title='Phone Number' className="px-4 2xl:px-6 py-3">{responseItem?.agencyDetails?.details?.referral?.phone ?? ""}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                    {agencyResponses[tab.key]?.length === 0 && activeTabs === 0 && (
                      <div>List of available beds for this case.</div>
                    )}
                    {agencyResponses[tab.key]?.length === 0 && activeTabs === 1 && (
                      <div>Currently, no beds are available.</div>
                    )}
                    {agencyResponses[tab.key]?.length === 0 && activeTabs === 2 && (
                      <div>No response from the shelter yet.</div>
                    )}
                  </div>
                ))}
              </div>
            </div>
            <div className="flex justify-end items-center mt-4 gap-3">
              <button
                type="button"
                className="min-h-[38px] min-w-24 py-2 bg-white border border-borderGray px-3 inline-flex justify-center items-center gap-x-2 text-sm rounded-lg"
                onClick={() => {
                  if (location.key !== "default") {
                    navigate(-1);
                  } else {
                    navigate("/bedfinder/my-requests", { replace: true });
                  }
                }}
              >
                <FiArrowLeft />
                <span>Back</span>
              </button>
              {request?.status == "open" && (
                <button className="btn-sm btn-error min-h-[38px]" onClick={openModal}>Close Request</button>
              )}
            </div>
          </div>
        </div>

        <ModalDailog isOpen={isModalOpen} handleSubmit={handleSubmit} closeRequest={closeRequestHandler} onClose={closeModal} title="Close Request" backButton="Go Back" primaryButton="Close This Request">
          <div className="card-header flex items-center justify-between mb-5 text-gray-600 font-medium">
            <div className="flex flex-wrap items-center space-x-4">
              <div className="flex items-center gap-3">
                <img src={LocateBed} alt="LocateBed" className="w-8" />
                <h3>
                  Case reference #:{" "}
                  <Link to="/" className="text-primary ms-3 font-semibold">
                    {request.need?.caseReferenceId}
                  </Link>
                </h3>
              </div>
              <span className="text-blue-100">|</span>
              <div>
                Request #:{" "}
                <Link to="/" className="text-primary font-semibold">
                  {request.nr}
                </Link>
              </div>
            </div>
            <div className="flex items-center">
              <FiCalendar className="me-3" size={20} />
              <span className="2xl:text-base">{formatDateTime(request.createdAt)}</span>
            </div>
          </div>
          <h4 className="text-gray-950 text-lg font-semibold">Why are you closing this request?</h4>
          <div className="radio-groups mt-5">
            {errors?.reason && (
              <label className="text-error">This field is required.</label>
            )}
            {closeReasons.map(reason => (
              <RadioButton
                label={reason} value={reason}
                selectedValue={selectedValue}
                radioClass="mb-3"
                {...register("reason", { required: true })}
              />
            ))}
            <RadioButton
              label="Other" value="other"
              selectedValue={selectedValue}
              radioClass="mb-3"
              {...register("reason", { required: true })}
            />
            <InputBox
              type="text"
              inputClass={"w-1/3"}
              placeholder="Please add other"
              {...register("other", {
                maxLength: 150,
                required: watch("reason") === "other",
                disabled: watch("reason") !== "other",
              })}
            />
            {errors.other?.type === "required" && (
              <label className="text-error">
                Please fill out this field.
              </label>
            )}
            {errors.other?.type === "maxLength" && (
              <label className="text-error">Text field too long.</label>
            )}
          </div>
        </ModalDailog>

        <ModalDailog isOpen={isModalOpenSheltercc} onClose={closeModalSheltercc} title={agencyData?.data?.name} isFooterAvailable={false}>
          <div className="card-header flex items-center justify-between mb-5 text-gray-600 font-medium">
            <div className="flex flex-wrap items-center space-x-4">
              {agencyData.isReferral && (
                <span className="py-1 px-3 rounded-full text-secondary 2xl:text-sm bg-blue-100">Referral Only</span>
              )}
              {agencyData.canAnswerRequest && (
                <span className="py-1 px-3 rounded-full text-white 2xl:text-sm bg-primary">Shelter</span>
              )}
              {agencyData.regionalSupporter && (
                <span className="py-1 px-3 rounded-full text-white 2xl:text-sm bg-secondary">Regional Supporter</span>
              )}
            </div>
            {agencyData?.data?.profile?.memberSince != "__private__" && (
              <div className="flex items-center">
                <FiCalendar className="me-3" size={20} />
                <span className="text-sm 2xl:text-base">Member since{" "}
                  {moment(agencyData?.data?.profile?.memberSince || agencyData?.data?.createdAt).format(
                    "MMMM YYYY",
                  )}
                </span>
              </div>
            )}
          </div>
          <div className="flex text-sm 2xl:text-base">
            <div className="md:w-1/2">
              <p className="text-dark mb-3">Location info:</p>
              <p className="text-gray-600">
                {agencyData.city}
                {agencyData.state ? ", " + agencyData.state : ""}
              </p>
              {agencyData?.data?.profile?.county != "__private__" && (
                <p>{agencyData?.data?.profile?.county}</p>
              )}
            </div>
            {agencyData.canAnswerRequest && (
              <div className="md:w-1/2">
                <p className="text-dark mb-3">About the shelter:</p>
                <Referral agency={agencyData.data} />
                <GendersServed agency={agencyData.data} />
                <RoomType agency={agencyData.data} />
                <AdaCompliant agency={agencyData.data} />
                <DisabilityAccessible agency={agencyData.data} />
                <PublicTransportation agency={agencyData.data} />
                <UrbanRuralClassification agency={agencyData.data} />
                <LocationType agency={agencyData.data} />
                <LGBTQFriendly agency={agencyData.data} isModal={isModalOpenSheltercc} />
                <ShelterInformationForthcoming agency={agencyData.data} />
              </div>
            )}
            {agencyData?.data?.profile?.website && isValidURL(agencyData.data.profile.website) && (
              <div className="md:w-1/3 mb-3 md:mb-0">
                <p className="text-dark font-medium mb-2 md:mb-3">Website</p>
                {agencyData.data?.profile.website != "__private__" && (
                  <a href={formatUrl(agencyData.data?.profile.website)} target="_blank" className="text-primary font-semibold break-words">
                    {agencyData.data?.profile.website}
                  </a>
                )}
              </div>
            )}
          </div>

        </ModalDailog>
      </>
    )
  )
}

interface Props {
  agency: Agency;
  isModal?: boolean;
}

const Referral: React.FC<Props> = ({ agency }) => {
  return agency.profile.referral ? <p>Referral agency only</p> : null;
};

const GendersServed: React.FC<Props> = ({ agency }) => {
  return agency.profile.gendersServed &&
    agency.profile.gendersServed !== "__private__" ?
    <p>{gendersServed[agency.profile.gendersServed]}</p> : null
}

const RoomType: React.FC<Props> = ({ agency }) => {
  return agency.profile.roomType &&
    agency.profile.roomType !== "__private__" ?
    <p>{roomType[agency.profile.roomType]}</p> : null
}

const AdaCompliant: React.FC<Props> = ({ agency }) => {
  return agency.profile.adaCompliant &&
    agency.profile.adaCompliant !== "__private__" &&
    !agency.profile.disabilityAccessible ?
    <p>{!agency.profile.adaCompliant ? "Not " : ""}ADA compliant</p> : null
}

const DisabilityAccessible: React.FC<Props> = ({ agency }) => {
  return agency.profile.disabilityAccessible &&
    agency.profile.disabilityAccessible !== "__private__" ?
    <p>{disabilityAccessible[`${agency.profile.disabilityAccessible}`]}</p> : null
}

const PublicTransportation: React.FC<Props> = ({ agency }) => {
  return agency.profile.publicTransportation &&
    agency.profile.publicTransportation !== "__private__" ?
    <p>
      {agency.profile.publicTransportation ? "Near" : "No nearby"} public
      transportation
    </p> : null
}

const UrbanRuralClassification: React.FC<Props> = ({ agency }) => {
  return agency.profile.urbanRuralClassification &&
    agency.profile.urbanRuralClassification !== "__private__" ?
    <p>{urbanRuralClassification[agency.profile.urbanRuralClassification]}</p> : null
}

const LocationType: React.FC<Props> = ({ agency }) => {
  return agency.profile.locationType &&
    agency.profile.locationType !== "__private__" ?
    <p>{locationType[agency.profile.locationType]}</p> : null
}

const LGBTQFriendly: React.FC<Props> = ({ agency, isModal }) => {

  const tooltipText = `Shelters responded Yes to at least one of the following questions:
          <br />* Does your organization provide tailored services and programs
          to people who identify as LGBTQ?
          <br />* Does your agency in general identify as an LGBTQ ally?`;

  return agency.profile.lgbtqFriendly !== "__private__" &&
    agency.profile.lgbtqFriendly ? (

    <p>
      <span id="lgbtq" className=""></span>
      <span className="flex items-center gap-1"><img src={lgbtqIcon} alt="lgbtqIcon" width={'25px'} /> LGBTQ friendly&nbsp;  <Tooltip text={tooltipText}><span className="cursor-pointer"><FaCircleInfo size="16" className="text-gray-600" /></span></Tooltip></span>
      <a className="popover-link" role="button">
        <span
          data-tooltip-id={
            isModal ? "modal-tooltip-" : "normal-tooltip-" + agency.agencyId
          }
          className="glyphicon glyphicon-info-sign tooltip-icon info"
        />
      </a>
    </p>
  ) : null
}

const ShelterInformationForthcoming: React.FC<Props> = ({ agency }) => {
  return !(
    (agency.profile.gendersServed &&
      agency.profile.gendersServed !== "__private__") ||
    (agency.profile.roomType && agency.profile.roomType !== "__private__") ||
    (agency.profile.adaCompliant &&
      agency.profile.adaCompliant !== "__private__") ||
    (agency.profile.disabilityAccessible &&
      agency.profile.disabilityAccessible !== "__private__") ||
    (agency.profile.publicTransportation &&
      agency.profile.publicTransportation !== "__private__") ||
    (agency.profile.urbanRuralClassification &&
      agency.profile.urbanRuralClassification !== "__private__") ||
    (agency.profile.locationType &&
      agency.profile.locationType !== "__private__") ||
    (agency.profile.lgbtqFriendly &&
      agency.profile.lgbtqFriendly !== "__private__") ||
    agency.profile.referral
  ) ? <p>Shelter information forthcoming.</p> : null;
}

export default SentDetail